import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core/public-api";

export const ACTION_PREFIX = "[Registration With IDIN]";

export const REGISTRATION_WITH_IDIN_ACTION_TYPE = {
	getIdinRegistrationUrl: `${ACTION_PREFIX} Get IDIN Registration URL`,
	getIdinRegistrationUrlSuccess: `${ACTION_PREFIX} Get IDIN Registration URL Success`,
	getIdinRegistrationUrlFail: `${ACTION_PREFIX} Get IDIN Registration URL Fail`,
};

@Injectable({
	providedIn: "root",
})
export class RegistrationWithIdinAction {
	getIdinRegistrationUrl(): Action {
		return {
			type: REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrl,
		};
	}

	getIdinRegistrationUrlSuccess(payload: string): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrlSuccess,
			payload,
		};
	}

	getIdinRegistrationUrlFail(payload: AppError): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrlFail,
			payload,
		};
	}
}
